import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import AppButton from '../common/AppButton';
import MainTitle from '../common/MainTitle';
import LocaleContext from '../../contexts/LocaleContext';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';
import ImageLink from '../../js/utils/ImageLink';

export default function LeadershipPotential({ data }) {
  console.log('LeadershipPotential', data);

  const { t } = useTranslation(['AboutPage']);
  const { locale } = useContext(LocaleContext);
  const { queryParams } = useNavigationWithQuery();

  return (
    <section className="leadership container">
      <div className="leadership__header mobile">
        <MainTitle type="dark" className="text--2xl">
          <span>{t('leadershipTitle1')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('leadershipTitle2')}
          </span>
          <span>{t('leadershipTitle3')}</span>
        </MainTitle>
      </div>
      <div className="leadership__media">
        {data?.map((image, index) => (
          <picture key={`leadership__media-${index}`}>
            <source srcSet={ImageLink(image?.url)} type="image/webp" />
            <img src={ImageLink(image?.url)} alt={image?.alt} className="left-img" />
          </picture>
        ))}
      </div>

      <div className="leadership__content">
        <div className="leadership__header desktop">
          <MainTitle type="dark" className="text--2xl">
            <span>{t('leadershipTitle1')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('leadershipTitle2')}
            </span>
            <span>{t('leadershipTitle3')}</span>
          </MainTitle>
        </div>
        <p>{t('leadershipText1')}</p>
        <p>{t('leadershipText2')}</p>

        <AppButton
          className="academic-programs"
          tag="a"
          linkPath={`/${locale}/academics${queryParams}`}>
          {t('leadershipButton')}
        </AppButton>
      </div>
    </section>
  );
}
